import { gql } from '@apollo/client';

export const CREATE_NE_MAN = gql`
  mutation createNeMan($neMan: NeManInput!) {
    createNeMan(neMan: $neMan) {
      id
    }
  }
`;
